import i18n from 'i18next';

const translations = [
    ["Welcome", "Welcome", "Witaj"],
    ["Set your password", "Please, set your password", "Proszę, ustaw swoje hasło"],
    ["Cancel", "Cancel", "Anuluj"],
    ["Yes", "Yes", "Tak"],
    ["No", "No", "Nie"],
    ["Continue", "Continue", "Kontynuuj"],
    ["Filter", "Filter", "Filtruj"],
    ["Set", "Set", "Ustaw"],
    ["Search", "Search", "Szukaj"],
    ["Clear", "Clear", "Wyczyść"],
    ["Save", "Save", "Zapisz"],
    ["Back", "Back", "Wstecz"],
    ["Next", "Next", "Dalej"],
    ["step", "Step", "Krok"],
    ["Edit", "Edit", "Edytuj"],
    ["Delete", "Delete", "Usuń"],
    ["Close", "Close", "Zamknij"],
    ["Open", "Open", "Otwórz"],
    ["Center map", "Center map", "Centruj mapę"],
    ["Project", "Workspace", "Projekt"],
    ["Projects", "Workspaces", "Projekty"],
    ["Users", "Users", "Użytkownicy"],
    ["Customers", "Customers", "Klienci"],
    ["Statistic", "Statistic", "Statystyka"],
    ["Map", "Map", "Mapa"],
    ["Videos", "Videos", "Filmy"],
    ["Photos", "Photos", "Zdjęcia"],
    ["Default", "Default", "Domyślne"],
    ["photos", "photos", "zdjęcia"],
    ["Orthophotomap", "Orthophotomap", "Ortofotomapa"],
    ["orto", "orthophotomap", "ortofotomapę"],
    ["Attachments", "Attachments", "Załączniki"],
    ["Attachment", "Attachment", "Załącznik"],
    ["attachment", "attachment", "załącznik"],
    ["DJI log file", "DJI log file", "Plik logu DJI"],
    ["Gallery", "Gallery", "Galeria"],
    ["Models", "3D Models", "Modele 3D"],
    ["Model", "3D Model", "Model 3D"],
    ["Metadata", "Metadata", "Metadane"],
    ["Menu", "Menu", "Menu"],
    ["Loading", "Loading", "Ładowanie"],
    ["Hide", "Hide", "Ukryj"],
    ["Settings", "Settings", "Ustawienia"],
    ["Change language", "Change language", "Zmień język"],
    ["Choose", "Choose", "Wybierz"],
    ["Choose client", "Choose client", "Wybierz klienta"],
    ["Name", "Name", "Nazwa"],
    ["Description", "Description", "Opis"],
    ["Create", "Create", "Utwórz"],
    ["Point", "Point", "Punkt"],
    ["Line", "Line", "Linia"],
    ["Polygon", "Polygon", "Obszar"],
    ["signIn", "Sign In", "Zaloguj"],
    ["SignOut", "Sign Out", "Wyloguj"],
    ["username", "username", "login"],
    ["password", "password", "hasło"],
    ["Login could not be empty", "Login could not be empty", "Login nie może być pusty"],
    ["Password could not be empty", "Password could not be empty", "Hasło nie może być puste"],
    ["old password", "current password", "aktualne hasło"],
    ["new password", "new password", "nowe hasło"],
    ["repeat new password", "retype new password", "powtórz nowe hasło"],
    ["Reset", "Reset", "Resetuj"],
    ["reset password", "reset password", "resetuj hasło"],
    ["Password reset", "Password reset", "Zmieniono hasło"],
    ["Passwords don't match", "Passwords don't match", "Hasła nie są identyczne"],
    ["remember", "Remember me", "Zapamiętaj mnie"],
    ["create account", "Create account", "Utwórz konto"],
    ["customer", "customer", "klient"],
    ["Register", "Register", "Zarejestruj"],
    ["forgot password", "Forgot password?", "Zapomniałeś hasła?"],
    ["lost activation link", "Lost activation link?", "Straciłeś link aktywacyjny?"],
    ["Your activation link has expired", "Your activation link has expired or is invalid. To get a new link, enter email address used to create the account:", "Wybrany link aktywacyjny stracił ważność lub jest nieprawidłowy. Żeby uzyskać nowy link podaj adres mailowy którego użyto do założenia konta:"],
    ["send link", "send link", "wyślij adres"],
    ["Send", "Send", "Wyślij"],
    ["Go back", "Go back", "Wróć"],
    ["Change password", "Change password", "Zmień hasło"],
    ["Change", "Change", "Zmień"],
    ["Enter new password", "Enter new password", "Podaj nowe hasło"],
    ["Change project", "Change workspace", "Zmień projekt"],
    ["test button", "test button", "testowy przycisk"],
    ["Missions", "Projects", "Misje"],
    ["Mission", "Project", "Misja"],
    ["Not chosen", "Not chosen", "Nie wybrano"],
    ["User", "User", "Użytkownik"],
    ["About mission", "About project", "O misji"],
    ["Add mission", "Add project", "Dodaj misję"],
    ["New mission", "New project", "Nowa misja"],
    ["Edit mission", "Edit project", "Edycja misji"],
    ["Mission list", "Project list", "Lista misji"],
    ["Draw geometry", "Draw geometry", "Rysuj geometrię"],
    ["Finish drawing", "Finish drawing", "Zakończ rysunek"],
    ["Choose geometry type", "Choose geometry type", "Wybierz typ geometrii"],
    ["Draw the geometry on the map", "Draw the project geometry on the map. Double click to finish.", "Narysuj geometrię misji na mapie. Dwuklik aby zakończyć rysowanie."],
    ["Edit mission area by drawing on the map", "Edit project area by drawing on the map.", "Edytuj obszar misji przez rysowanie na mapie."],
    ["Previous photo", "Previous photo", "Poprzednie zdjęcie"],
    ["Next photo", "Next photo", "Następne zdjęcie"],
    ["Synchronize", "Synchronize", "Włącz synchronizację"],
    ["Desynchronize", "Desynchronize", "Wyłącz synchronizację"],
    ["Reverse browser order", "Reverse browser order", "Odwróć kierunek przeglądania"],
    ["Delete photo", "Delete photo", "Usuń zdjęcie"],
    ["Do you really want to delete photo", "Do you really want to delete photo", "Czy na pewno chcesz usunąć zdjęcie"],
    ["Do you really want to delete resource", "Do you really want to delete attachment", "Czy na pewno chcesz usunąć załącznik"],
    ["Select project", "Select project", "Wybierz projekt"],
    ["Previous video", "Previous video", "Poprzedni film"],
    ["Next video", "Next video", "Następny film"],
    ["Previous model", "Previous model", "Poprzedni model"],
    ["Next model", "Next model", "Następny model"],
    ["Attributes", "Attributes", "Atrybuty"],
    ["Layer list", "Layer list", "Lista warstw"],
    ["Main layers", "Main layers", "Warstwy bazowe"],
    ["Point layers", "Point layers", "Warstwy punktowe"],
    ["Line layers", "Line layers", "Warstwy liniowe"],
    ["Polygon layers", "Polygon layers", "Warstwy poligonowe"],
    ["Ortho Images", "Ortho Images", "Ortofotomapy"],
    ["Elevation layers", "Elevation layers", "Warstwy NMT"],
    ["Other layers", "Other layers", "Pozostałe warstwy"],
    ["Measure tools", "Measure tools", "Narzędzia pomiarowe"],
    ["Measurements", "Measurements", "Pomiary"],
    ["Last measurement", "Last measurement", "Ostatni pomiar"],
    ["2000 zone 5", "2000: zone 5", "2000: strefa 5"],
    ["2000 zone 6", "2000: zone 6", "2000: strefa 6"],
    ["2000 zone 7", "2000: zone 7", "2000: strefa 7"],
    ["2000 zone 8", "2000: zone 8", "2000: strefa 8"],
    ["Coordinates", "Coordinates", "Współrzędne"],
    ["Distance", "Distance", "Odległość"],
    ["Area", "Area", "Powierzchnia"],
    ["Base maps", "Base maps", "Mapy bazowe"],
    ["Mean depths full coverage", "Mean depths full coverage", "Średnie głębokości z lądami"],
    ["Mean depths multi colour", "Mean depths multi colour", "Średnie głębokości - wielobarwna"],
    ["Data displayed on this basemap was made available by the EMODnet Bathymetry project (by EMODnet Bathymetry Consortium)", "Data displayed on this basemap was made available by the EMODnet Bathymetry project (by EMODnet Bathymetry Consortium)", "Dane wyświetlanej mapy podkładowej zostały udostępnione przez projekt EMODnet Bathymetry (realizowany przez EMODnet Bathymetry Consortium)"],
    ["funded by the European Commission Directorate General for Maritime Affairs and Fisheries. The data originators can be checked", "funded by the European Commission Directorate General for Maritime Affairs and Fisheries. The data originators can be checked", "finansowany przez Dyrekcję Generalną ds. Gospodarki Morskiej i Rybołówstwa Komisji Europejskiej. Szczegółowy opis danych źródłowych znajduję się"],
    ["Legend", "Legend", "Legenda"],
    ["Zoom in", "Zoom in", "Powiększ"],
    ["Zoom out", "Zoom out", "Pomniejsz"],
    ["Attributions", "Attributions", "Mapa podkładowa - informacje"],
    ["No videos for chosen mission", "No videos for chosen project", "Brak filmów dla wybranej misji"],
    ["No models for chosen mission", "No models for chosen mission", "Brak modeli dla wybranej misji"],
    ["Do you really want to delete selected files", "Do you really want to delete selected files", "Czy na pewno chcesz usunąć wybrane pliki"],
    ["Do you really want to delete video", "Do you really want to delete video", "Czy na pewno chcesz usunąć film"],
    ["Do you really want to delete mission", "Do you really want to delete project", "Czy na pewno chcesz usunąć misję"],
    ["Load for", "Load for", "Wczytaj dla"],
    ["No photos for chosen mission", "No photos for chosen project", "Brak zdjęć dla wybranej misji"],
    ["No mission selected please select", "No project selected. Please select project from the left panel.", "Brak wybranej misji. Proszę wybrać misję z lewego panelu."],
    ["No mission selected please select for create label", "No project selected. Please select project from the Projects tab.", "Brak wybranej misji. Proszę wybrać misję z zakładki Misje."],
    ["No fault selected please select", "No fault selected. Please select fault from the left panel.", "Brak wybranej awarii. Proszę wybrać awarię z lewego panelu."],
    ["No attachments for mission", "You will see attachments from selected project here.", "Tu będą widoczne załączniki związane z wybraną misją."],
    ["No attachments", "No attachments for this project.", "Brak załączników dla tego projektu."],
    ["This thumbnail is not longer available.", "This thumbnail is not longer available.", "Miniaturka nie jest dostępna."],
    ["Photo is still being proccessed", "Photo is still being proccessed. Zoom will be avalaible soon.", "Zdjęcie jest wciąż przetwarzane. Podgląd będzię dostępny wkrótce."],
    ["No mission selected", "No project selected", "Brak wybranej misji"],
    ["Back to upload menu", "Back to upload menu", "Powrót do menu wysyłania"],
    ["Back to login page", "Back to login page", "Powrót do strony logowania"],
    ["Metadata upload panel", "Metadata upload panel", "Panel do wgrywania metadanych"],
    ["SHP upload panel", "SHP upload panel", "Panel do wgrywania plików .shp"],
    ["Layer name", "Layer name", "Nazwa warstwy"],
    ["Attachment description", "Attachment description", "Opis załącznika"],
    ["Layer with that name will be created in current project", "Layer with that name will be created in current workspace.", "Warstwa o takiej nazwie zostanie utworzona w projekcie."],
    ["description", "description", "opis"],
    ["Model description", "3D Model description", "Opis modelu 3D"],
    ["Model name", "Name for 3D Model", "Nazwa dla modelu 3D"],
    ["3D Model link on sketchfab", "3D Model link on sketchfab or sketchfab uid", "Link do modelu 3D na sketchfab lub sketchfab uid"],
    ["Only sketchfab links are supported", "Only sketchfab links are supported.", "Wspierane są tylko linki do sketchfab."],
    ["Model not found", "No model was found with the specified uid", "Nie znaleziono modelu o podanym uid"],
    ["Photo file should countains EXIF metadata with photo location", "Photo file should countains EXIF metadata with photo location.", "Plik zdjęcia powinien zawierać metadane EXIF z informacją o lokalizacji zdjęcia."],
    ["Only mp4 video format is supported", 
        "Only .mp4 video format is supported. Video compression standard supported up to H.264. For movies that will be linked to DJI log files, the modification date of the file can not be changed.", 
        "Wspierane są tylko filmy w formacie .mp4. Wspierany standard kodowania plików do wersji H.264. Dla filmów, które będą połączone z plikami logów DJI data modyfikacji pliku nie może zostać zmieniona."],
    ["All files should be packed into zip format", "All files should be packed into .zip format. ", "Pliki spakuj do formatu .zip. "],
    ["Uploaded file should be in one of", "Uploaded file should be in one of", "Wgrywany plik powinien być w jednym"],
    ["Uploaded files should be in one of", "Uploaded files should be in one of", "Wgrywane pliki powinny być w jednym"],
    ["the supported coordinate systems", "the supported coordinate systems.", "ze wspieranych układów współrzędnych."],
    ["WGS84 is the recommended coordinate system",
        "WGS84 (EPSG:3857) is the recommended coordinate system for data uploaded into the application. The data will be displayed in this coordinate system. In case of uploading data in different coordinate system based on the WGS84 ellipsoid (eg. UTM) the transformation will be lossless or with slight distortion.",
        "Rekomendowanym układem współrzędnych dla danych wgrywanych do aplikacji jest WGS84 (EPSG:3857). Dane będą wyświetlane w tym układzie współrzędnych. W przypadku wgrania danych w innym układzie opartym o elipsoidę WGS84 (np. UTM) transformacja będzie bezstratna lub obarczona niewielkim zniekształceniem."],
    ["The other supported coordinate systems", "The other supported coordinate systems:", "Wspierane pozostałe układy współrzędnych to:"],
    ["OSGB 1936", "OSGB 1936 -  according to the OSTN15/OSGM15 transformation", "OSGB 1936 - zgodnie z transformacją OSTN15/OSGM15"],
    ["At least dbf, shp, shx and prj files are requeired", "Zip file should contains at least .dbf, .shp, .shx and .prj files. ", "Paczka .zip powinna zawaierać co najmniej pliki .dbf, .shx, .shp oraz .prj. "],
    ["Orthophotomap should be in geotiff format with tiles", "Orthophotomap should be in GeoTIFF file format with tiles.", "Ortofotomapa powinna być zapisana w formacie GeoTIFF z wewnętrznymi piramidami."],
    ["Only DJI flight logs are supported", "Only DJI flight logs are supported.", "Wspierane są tylko pliki logów DJI."],
    ["Select time zone", "Select time zone", "Wybierz strefę czasową"],
    ["Attachment could be a file of any type", "Attachment could be a file of any type.", "Załącznikiem może być plik dowolnego typu."],
    ["ex Buildings", "ex. Buildings", "np. Budynki"],
    ["ex Orthomosaic", "ex. Orthomosaic", "np. Ortofotomapa"],
    ["Photo upload panel", "Photo upload panel", "Panel do wgrywania zdjęć"],
    ["Video upload panel", "Video upload panel", "Panel do wgrywania filmów"],
    ["Orthophotomap upload panel", "Orthophotomap upload panel", "Panel do wgrywania ortofotomap"],
    ["Model upload panel", "3D Model upload panel", "Panel do wgrywania modeli 3D"],
    ["Attachment upload panel", "Attachment upload panel", "Panel do wgrywania załączników"],
    ["Drop photos", "Drop photos", "Upuść pliki zdjęć"],
    ["Drop video", "Drop .mp4 file", "Upuść plik .mp4"],
    ["Drop metadata", "Drop metadata", "Upuść metadane"],
    ["Drop zip file", "Drop .zip file", "Upuść plik .zip"],
    ["Drop log file", "Drop log file", "Upuść plik log"],
    ["Drop geotiff file", "Drop .geotiff file", "Upuść plik .geotiff"],
    ["Drop file", "Drop file", "Upuść plik"],
    ["Drop", "Drop", "Upuść"],
    ["or click to browse files", "or click to browse files", "lub kliknij aby wybrać pliki"],
    ["or click to browse file", "or click to browse file", "lub kliknij aby wybrać plik"],
    ["Drop logo or click to browse file", "Drop logo or click to browse file", "Upuść logo lub kliknij aby wybrać plik"],
    ["There is no logo for this customer", "There is no logo for this customer", "Klient nie posiada logo"],
    ["use current", "Use current logo", "Użyj obecnego logo"],
    ["No preview for this file format", "No preview for this file format", "Brak podglądu dla tego formatu plików"],
    ["Set to all files", "Set to all files", "Ustaw tą wartość wszystkim plikom"],
    ["Files", "Files", "Pliki"],
    ["ID", "ID", "ID"],
    ["Project name", "Project name", "Nazwa misji"],
    ["Project name could not be empty", "Project name could not be empty", "Nazwa misji nie może być pusta"],
    ["Project number", "Project number", "Numer misji"],
    ["Project manager", "Project manager", "Kierownik misji"],
    ["Start point", "Start point", "Punkt startowy"],
    ["Location", "Location", "Miejsce"],
    ["Voltage", "Voltage", "Poziom napięcia"],
    ["Mission category", "Project category", "Kategoria misji"],
    ["Status", "Status", "Status"],
    ["Planned start time", "Planned start time", "Planowany czas startu"],
    ["Flight duration", "Flight duration", "Czas lotu"],
    ["Flight length", "Flight length", "Długość lotu"],
    ["Start time", "Start time", "Czas startu"],
    ["End time", "End time", "Czas zakończenia"],
    ["Products", "Products", "Produkty"],
    ["Report", "Report", "Raport"],
    ["Drone", "Drone type", "Typ drona"],
    ["Multirotor", "Multirotor", "Wirnikowiec"],
    ["Fixedwing", "Fixedwing", "Płatowiec"],
    ["Other", "Other", "Inny"],
    ["Date surveyed", "Date surveyed", "Data pomiaru"],
    ["Order products", "Order products", "Przedmioty zamówienia"],
    ["Created by", "Created by", "Utworzony przez"],
    ["Created on", "Created on", "Data utworzenia"],
    ["Modified by", "Modified by", "Modyfikowany przez"],
    ["Modified on", "Modified on", "Data modyfikacji"],
    ["Modified by (id)", "Modified by (id)", "Zmodyfikowany przez (id)"],
    ["Choose flight category", "Choose flight category", "Wybierz kategorię misji"],
    ["Choose fault category", "Choose fault category", "Wybierz kategorię awarii"],
    ["Choose fault type", "Choose fault type", "Wybierz typ awarii"],
    ["Emergency", "Emergency", "Awaryjny"],
    ["Preventive", "Preventive", "Prewencyjny"],
    ["Planned", "Planned", "Planowy"],
    ["Proposed", "Proposed", "Proponowany"],
    ["Verified", "Verified", "Zweryfikowany"],
    ["In progress", "In progress", "W realizacji"],
    ["Completed", "Completed", "Zakończony"],
    ["Stream LIVE", "Stream LIVE", "Transmisja LIVE"],
    ["Thermography", "Thermography", "Termowizja"],
    ["Multispectral image", "Multispectral images", "Obrazy multispektralne"],
    ["Distance measurements", "Distance measurements", "Pomiar odległości"],
    ["DTM", "DTM", "NMT"],
    ["dtm", "DTM", "NMT"],
    ["DSM", "DSM", "NMPT"],
    ["Point cloud", "Point cloud", "Chmura punktów"],
    ["Example layers", "Example layers", "Warstwy demonstracyjne"],
    ["User layers", "User layers", "Warstwy użytkownika"],
    ["Lines", "Lines", "Odcinki"],
    ["Poles", "Poles", "Slupy"],
    ["Flight path", "Flight path", "Trasy lotów"],
    ["DTM transparent 50%", "DTM transparent 50%", "NMT przeźroczysty 50%"],
    ["DSM transparent 50%", "DSM transparent 50%", "NMPT przeźroczysty 50%"],
    ["Project transparent 50%", "Project transparent 50%", "Projekt przeźroczysty 50%"],
    ["Orthophotomap_T", "Orthophotomap_T", "Ortofotomapa_T"],
    ["Mission range", "Project range", "Zakres misji"],
    ["Buildings", "Buildings", "Budynki"],
    ["Planned flight path", "Planned flight path", "Planowana trasa lotu"],
    ["Underground electrical grid", "Underground electrical grid", "Sieć elektroenergetyczna podziemna"],
    ["Electrical grid", "Electrical grid", "Sieć elektroenergetyczna"],
    ["Contours", "Contours", "Warstwice"],
    ["Others grids", "Others grids", "Inne sieci"],
    ["Electrical poles", "Electrical poles", "Słupy elektroenergetyczne"],
    ["GCP", "GCP", "Fotopunkty"],
    ["Measured marks", "Measured marks", "Pomierzone markery"],
    ["Faults", "Faults", "Awarie"],
    ["Dangers", "Dangers", "Zagrożenia"],
    ["Air zones", "Air zones", "Strefy lotnicze"],
    ["Tracks", "Tracks", "Sieć trakcyjna"],
    ["Wires", "Wires", "Przewody"],
    ["Delete layer", "Delete layer", "Usuń warstwę"],
    ["Delete resource", "Delete file", "Usuń plik"],
    ["Download file", "Download file", "Pobierz plik"],
    ["Download files", "Download files", "Pobierz pliki"],
    ["Zoom to layer", "Zoom to layer", "Przybliż do warstwy"],
    ["Change layer style", "Change layer style", "Zmień styl warstwy"],
    ["Move up", "Move up", "Przesuń w górę"],
    ["Move down", "Move down", "Przesuń w dół"],
    ["Choose new style for layer", "Choose new style for layer", "Wybierz nowy styl dla warstwy"],
    ["Opacity", "Transparency", "Przeźroczystość"],
    ["Change style", "Change style", "Zmień styl"],
    ["Do you really want to delete layer and related data", "Do you really want to delete layer and related data", "Czy na pewno chcesz usunąć warstwę i powiązane z nią dane"],
    ["Map data", "Map data", "Produkty mapowe"],
    ["Tasks", "Tasks", "Zadania"],
    ["More", "More", "Inne"],
    ["Infrastructure", "Infrastructure", "Infrastruktura"],
    ["Beginning time", "Beginning time", "Czas rozpoczęcia"],
    ["Created by (id)", "Created by (id)", "Utworzono przez (id)"],
    ["Created by (name)", "Created by (name)", "Utworzono przez (nazwa)"],
    ["Duration", "Duration", "Czas trwania"],
    ["File name", "File name", "Nazwa pliku"],
    ["Flight Id", "Flight Id", "Id lotu"],
    ["Movie Id", "Movie Id", "Id filmu"],
    ["Latitude", "Latitude", "Szerokość"],
    ["Longtitude", "Longtitude", "Długość"],
    ["Altitude", "Altitude", "Wysokość"],
    ["Date", "Date", "Data"],
    ["Time", "Time", "Czas"],
    ["Photo direction", "Photo direction", "Kierunek zdjęcia"],
    ["Front photo", "Front", "Przód"],
    ["Back photo", "Back", "Tył"],
    ["Nadir photo", "Nadir", "Góra"],
    ["Pause", "Pause", "Zatrzymaj"],
    ["Resume", "Resume", "Wznów"],
    ["Uploading file", "Uploading file", "Wysyłanie pliku"],
    ["Upload finished", "Upload finished", "Zakończono wysyłanie"],
    ["upload_finished", "Upload finished", "Zakończono wysyłanie pliku"],
    ["upload_finished_many", "{amount} files uploaded", "Zakończono wysyłanie {amount} plików"],
    ["Upload failed", "Upload failed", "Wysyłanie przerwane"],
    ["Upload canceled", "Upload canceled", "Wysyłanie anulowane"],
    ["Upload resumed", "Upload resumed", "Wysyłanie wznowione"],
    ["Upload paused", "Upload paused", "Wysyłanie zatrzymane"],
    ["Upload", "Upload", "Wyślij"],
    ["Error", "Error", "Błąd"],
    ["Upload in progress", "Upload in progress", "Wysyłanie w toku"],
    ["Uploading", "Uploading", "Wysyłanie"],
    ["Upload completed", "Upload completed", "Wysyłanie zakończone"],
    ["image", "image", "zdjęcia"],
    ["metadata", "metadata", "metadane"],
    ["video", "video", "film"],
    ["drone", "DJI log file", "Plik logu DJI"],
    ["rasterLayer", "raster layer", "warstwę rastrową"],
    ["shpLayer", "vector layer", "warstwę wektorową"],
    ["Network Error", "Network error", "Błąd sieci"],
    ["Error occured while deleting photo", "Error occured while deleting photo", "Wystąpił błąd podczas usuwania zdjęcia"],
    ["Error occured while deleting video", "Error occured while deleting video", "Wystąpił błąd podczas usuwania filmu"],
    ["Error occured while deleting model", "Error occured while deleting model", "Wystąpił błąd podczas usuwania modelu"],
    ["Error occured while deleting attachment", "Error occured while deleting attachment", "Wystąpił błąd podczas usuwania załącznika"],
    ["Error occured while deleting layer", "Error occured while deleting layer", "Wystąpił błąd podczas usuwania warstwy"],
    ["Layer deleted", "Layer deleted", "Usunięto warstwę"],
    ["Attachment deleted", "Attachment deleted", "Usunięto załącznik"],
    ["Mission edited", "Project edited", "Edycja misji zakończona"],
    ["Mission added", "Project added", "Misja dodana"],
    ["What to administrate", "What to administrate", "Czym chcesz zarządzać"],
    ["Administrating", "Administrating", "Zarządzanie"],
    ["You are not an admin", "You are not an admin", "Nie jesteś administratorem"],
    ["no customer selected", "no customer selected", "nie wybrano klienta"],
    ["Link has been sent", "Link has been sent", "Link został wysłany"],
    ["Enter email associated with your account", "Enter email associated with your account", "Podaj mail powiązany z Twoim kontem"],
    ["If you lost your activation link", "If you lost your activation link", "Jeśli straciłeś link aktywacyjny"],
    ["If you forgot your password", "If you forgot your password", "Jeśli zapomniałeś hasła"],
    ["Cannot get location", "Cannot get location. Check if your browser has access to your location.", "Nie można ustalić położenia. Sprawdź, czy przeglądarka ma dostęp do Twojej lokalizacji."],
    ["New password must be different than the old one", "New password must be different than the old one", "Nowe hasło musi różnić się od aktualnego"],
    ["Passwords does not match", "Passwords does not match", "Podane hasła nie są identyczne"],
    ["We'll send you a mail with link to reset yout password", "We'll send you a mail with link to reset yout password", "Na podany email wyślemy link pozwalający na reset hasła"],
    ["We'll send you confirmation link to this address", "We'll send you confirmation link to this address", "Pod ten adres wyślemy link aktywacyjny"],
    ["Customer name", "Customer name", "Nazwa klienta"],
    ["Your company name or your username", "Your company name or your username", "Nazwa instytucji lub klienta"],
    ["First name", "First name", "Imię"],
    ["We need your forename for account verification", "We need your forename for account verification", "Imię jest potrzebne do weryfikacji użytkownika"],
    ["We need your surname for account verification", "We need your surname for account verification", "Nazwisko jest potrzebne do weryfikacji użytkownika"],
    ["Last name", "Last name", "Nazwisko"],
    ["Password", "Password", "Hasło"],
    ["Type 6 characters or more", "Type 6 characters or more", "Wpisz 6 lub więcej znaków"],
    ["Confirm password", "Confirm password", "Potwierdź hasło"],
    ["Type your password again", "Type your password again", "Ponownie wpisz hasło"],
    ["Phone", "Phone", "Telefon"],
    ["We'll contact you if you have a problem with our app", "We'll contact you if you have a problem with our app", "Skontaktujemy sie w razie problemów z aplikacją"],
    ["You can draw mission geometry", "You can draw project geometry. Select geometry type and draw it on the map.", "Możesz dodać geometrię misji. Wybierz typ geometrii i narysuj ją na mapie."],
    ["Select project geometry type", "Select project geometry type", "Wybierz rodzaj geometrii misji"],
    ["Click to start drawing geometry on the map", "Click to start drawing geometry on the map.", "Kliknij aby rozpocząć rysowanie na mapie."],
    ["Double click on the map to finish", "Double click on the map to finish.", "Dwuklik na mapie, by zakończyć."],
    ["Confirmation mail has been sent", "Confirmation mail has been sent!", "Wiadomość z potwierdzeniem rejestracji została wysłana!"],
    ["You are not assigned to any projects", "You are not assigned to any workspaces.", "Nie jesteś przypisany do żadnego projektu."],
    ["You dont have necessary permissions", "You don't have necessary permissions.", "Nie posiadasz wystarczających uprawnień"],
    ["Manage your account", "Manage your account", "Zarządzaj swoim kontem"],
    ["Pilot will fill that information", "Pilot will fill that information", "Pilot wypełni te informacje"],
    ["In trial version you can only upload", "In trial version you can only upload", "W wersji testowej możesz wgrać tylko"],
    ["In trial version you cannot upload video", "In trial version you cannot upload any videos.", "W wersji testowej nie możesz wgrywać filmów."],
    ["photos per mission", "photos per project", "zdjęć na misję"],
    ["Client data size limit has been reached", "Client data size limit has been reached. Remove some existing data(ex.photos, movies) or change license to add new data.", "Limit danych został osiągnięty. Usuń część danych (np. zdjęć lub filmów) albo zmień rodzaj licencji aby dodać więcej danych."],
    ["Livestream started", "Livestream started", "Rozpoczęła się transmisja na żywo"],
    ["Select flight", "Select flight", "Wybierz lot"],
    ["go to video tab and click LIVE button", "go to video tab and click LIVE button", "przejdź do zakładki video i kliknij LIVE"],
    ["Livestream finished", "Livestream finished", "Zakończono transmisję na żywo"],
    ["Select layer", "Select layer", "Wybierz warstwę"],
    ["Select field", "Select field", "Wybierz pole"],
    ["Contact", "Contact", "Kontakt"],
    ["Labels", "Labels", "Etykiety"],
    ["Label settings", "Label settings", "Ustawienia etykiet"],
    ["Set label", "Set label", "Ustaw etykietę"],
    ["Clear label", "Clear label", "Wyczyść etykiety"],
    ["Mark on map", "Mark on map", "Zaznacz na mapie"],
    ["Mark on photo", "Mark on photo", "Zaznacz na zdjęciu"],
    ["Set video timestamp", "Set video timestamp", "Ustaw znacznik czasu"],
    ["Cancel marking", "Cancel marking", "Anuluj zaznaczanie"],
    ["To upload orthophotomap, please contact us at", "To upload orthophotomap, please contact us at", "Aby wgrać ortofotomapę, skontaktuj się z nami pod"],
    ["Manual", "Manual", "Pomoc"],
    ["Get DRONonLine Manual", "Get application manual", "Pobierz instrukcję"],
    ["_Manual", "_Manual", "_Instrukcja"],

    ["Project Id", "Project Id", "Id Projektu"],
    ["Do you really want to delete that fault", "Do you really want to delete that fault", "Na pewno chcesz usunąć tę awarię"],
    ["You can mark fault on map", "You can mark fault on map", "Możesz oznaczyć awarię na mapie"],
    ["Click on the button then on the map to mark fault", "Click on the button, then on the map to mark fault", "Kliknij w przycisk, następnie w mapę aby oznaczyć awarię"],
    ["Click on the button then on the photo to mark fault", "Click on the button then on the photo to mark fault", "Kliknij w przycisk, następnie w zdjęcie aby oznaczyć awarię"],
    ["Delete selected mark from photo", "Delete selected mark from photo", "Usuń wybrane oznaczenie ze zdjęcia"],
    ["Do you really want to delete that fault from photo", "Do you really want to delete that fault from photo?", "Czy na pewno chcesz usunąć wybrane oznaczenie usterki ze zdjęcia?"],
    ["Do you really want to delete that video fault relation", "Do you really want to delete that video fault relation?", "Czy na pewno chcesz usunąć powiązanie filmu z usterką?"],
    ["Do you really want to delete photo mark", "Do you really want to delete photo mark", "Czy na pewno chcesz usunąć oznaczenie na zdjęciu"],
    ["Video fault relation deleted", "Video fault relation deleted", "Powiązanie filmu z usterką zostało usunięte"],
    ["Fault deleted from photo", "Fault deleted from photo", "Awaria usunięta ze zdjęcia"],
    ["Visible on videos", "Visible on videos", "Widoczna na filmach"],
    ["Visible on", "Visible on", "Widoczna w"],
    ["Add comment", "Add comment", "Dodaj komentarz"],
    ["Edit comment", "Edit comment", "Edytuj komentarz"],
    ["Comments", "Comments", "Komentarze"],
    ["Comment created", "Comment created", "Utworzono komentarz"],
    ["Comment edited", "Comment edited", "Zakończono edycję komentarza"],
    ["Comment deleted", "Comment deleted", "Usunięto komentarz"],
    ["New comment", "New comment", "Nowy komentarz"],
    ["Click on the button then on the map to mark comment", "Click on the button, then on the map to mark comment", "Kliknij w przycisk, następnie w mapę aby oznaczyć komentarz"],
    ["It is a good day for flying", "It's a good day flying", "To jest idealny dzień na latanie"],
    ["Do you really want to delete that comment", "Do you really want to delete that comment?", "Czy na pewno chcesz usunąć ten komentarz?"],
    ["normal", "normal", "zwykły"],
    ["shorten", "shorten", "przycięty"],
    ["wrap", "wrap", "zawinięty"],
    ["center", "center", "centrowanie"],
    ["left", "left", "lewa"],
    ["right", "right", "prawa"],
    ["Layer", "Layer", "Warstwa"],
    ["Attribute", "Attribute", "Atrybut"],
    ["Style", "Style", "Styl"],
    ["Min zoom", "Min. zoom", "Min. powiększenie"],
    ["Align", "Align", "Wyrównanie"],
    ["Rotation", "Rotation", "Obrót"],
    ["Size", "Size", "Rozmiar"],
    ["Offset", "Offset", "Przesunięcie"],
    ["Adjustment", "Adjustment", "Dostosowanie"],
    ["Contrast", "Contrast", "Kontrast"],
    ["Brightness", "Brightness", "Jasność"],
    ["Accept", "Accept", "Akceptuj"],
    ["Do you accept our data management policy", "Your personal data will be administrated by GISonLine based on {address}. Providing data is voluntary, but also necessary to use the portal. The data owner has right to access their data, correct it, reduce processing and object against processing of his / her data. We also inform about the right to be forgotten, by requesting the administrator to delete personal data.", "Administratorem Danych Osobowych będzie firma GISonLine z siedzibą ul. {address}. Podanie danych jest dobrowolne, jak również niezbędne do korzystania z portalu. Osobie, której dane dotyczą, przysługuje prawo dostępu do treści swoich danych oraz ich poprawiania, ograniczenia oraz sprzeciwu wobec ich przetwarzania. Informujemy również o prawie bycia zapomnianym poprzez wystąpienie z wnioskiem do administratora o usunięcie danych osobowych."],
    ["Do you accept our cookie policy", "GISonLine use cookies to give you better performance. Continue if you accept cookies.", "GISonLine wykorzystuje pliki cookies, aby świadczyć usługi na najwyższym poziomie. Dalsze korzystanie ze strony oznacza, że zgadzasz się na ich użycie."],
    ["Describe mission location", "Describe project location", "Opisz lokalizację misji"],
    ["Voltage of the power line you are interested in", "Voltage of the power line you are interested in", "Poziom napięcia wybranej linii"],
    ["Set mission status", "Set project status", "Ustaw status misji"],
    ["A link for 3D object model", "A link for 3D object model", "Link do modelu 3D"],
    ["A link for mission report", "A link for project report", "Link do raporu z misji"],
    ["Invalid credentials", "Invalid credentials", "Błędne dane logowania"],
    ["Invalid request data", "Invalid request data", "Wprowadzono błędne dane"],
    ["Mission could not be deleted", "Project could not be deleted. Related layers, photos, videos, models or attachments exists", "Misja nie może być usunięta. Istnieją powiązane warstwy, zdjęcia, filmy, modele lub załączniki"],
    ["Password has been changed", "Password has been changed", "Hasło zostało zmienione"],
    ["GeoServer error", "GeoServer error. Problem with sent data", "Błąd GeoServera. Problem z przesłanymi danymi"],
    ["Maximum file upload size is", "Maximum file upload size is", "Maksymalny rozmiar pliku wynosi"],
    ["filter by map extend", "Filter by map extend", "Ogranicz do widocznych na mapie"],

    //TilesGalleryWrapper
    ["Mark fault", "Mark fault", "Zaznacz awarię"],

    //FaultCreator
    ["New fault", "New fault", "Nowa awaria"],
    ["Edit fault", "Edit fault", "Edytuj awarię"],
    ["Add tag", "Add tag", "Dodaj etykietę"],
    ["Fault description could not be empty", "Fault description could not be empty", "Opis usterki nie może być pusty"],
    ["Photo mark created", "Photo mark created", "Zaznaczono usterkę na zdjęciu"],
    ["Canceled", "Canceled", "Anulowano"],
    
    //FaultManager    
    ["Add fault", "Add fault", "Dodaj awarię"],
    ["Search by tag", "Search by tag", "Wyszukaj na podstawie etykiety"],
    ["Fault created", "Fault created", "Utworzono awarię"],
    ["Fault edited", "Fault edited", "Zakończono edycję awarii"],
    ["Fault deleted", "Fault deleted", "Usunięto awarię"],
    ["Click on the tag from list below to assign it to the fault", "Click on the tag from list below to assign it to the fault" ,"Kliknij na tag z listy poniżej, w celu przypisania go do awarii"],
    ["Tags", "Tags", "Tagi"],
    ["Click on the tag from list below to filter results", "Click on the tag from list below to filter results", "Wybierz tag z listy poniżej w celu przefiltrowania wyników"],

    //FaultTags
    ["Stacja transformatorowa", "Transformer station", "Stacja transformatorowa"],
    ["Konstrukcja wsporcza", "Support structure", "Konstrukcja wsporcza"],
    ["Fundament", "Foundation", "Fundament"],
    ["Uziemienie", "Earthing", "Uziemienie"],
    ["Izolacja", "Insulator", "Izolacja"],
    ["Łącznik", "Connector", "Łącznik"],
    ["Ogranicznik przepięć", "Surge arrester", "Ogranicznik przepięć"],
    ["Głowica kablowa", "Cable terminator", "Głowica kablowa"],
    ["Przewód", "Cable", "Przewód"],
    ["Przyłącze", "Terminal", "Przyłącze"],
    ["Przęsło", "Span", "Przęsło"],
    ["Trasa linii", "Route of the line", "Trasa linii"],
    ["Lampa oświetlenia ulicznego", "External lighting", "Lampa oświetlenia ulicznego"],
    ["Szafa/złącze", "Cable distribution cabinet/connector", "Szafa/złącze"],
    ["Elementy metalowe", "Steel parts", "Elementy metalowe"],
    ["Inne", "Others", "Inne"],

    //FautltCategory
    ["Critical condition", "Critical condition", "Stan krytyczny"],
    ["Warning", "Warning", "Ostrzeżenie"],
    ["Information", "Information", "Informacja"],

    //FaultAttributesContainer
    ["About fault", "About fault", "O awarii"],
    ["Fault category", "Fault category", "Kategoria awarii"],
    ["Fault type", "Fault type", "Typ awarii"],

    //FaultPhotosContainer
    ["Fault photos", "Fault photos", "Zdjęcia awarii"],

    //ChooseProjectForm
    ["Manage workspaces", "Manage workspaces", "Zarządzaj projektami"],
    ["Confirm", "Confirm", "Potwierdź"],
    ["Choose workspace", "Choose workspace", "Wybierz projekt"],
    ["First project with demo data created", "First project with demo data created", "Uworzono pierwszy projekt z danymi demo"],
    ["Demo data", "Demo data", "Dane demo"],
    ["Workspace is empty Would you like to create first project with demo data", "Workspace is empty. Would you like to create first project with demo data?", "Projekt jest pusty. Czy chcesz utworzyć pierwszą misję z danymi demo?"],
    ["Please wait Creating demo data", "Please wait. Creating demo data...", "Proszę czekać. Tworzenie danych demo..."],
    ["Your license has expired", "Your license has expired", "Twoja licencja wygasła"],

    //CustomerAdmin
    ["Create new customer", "Create new customer", "Utwórz klienta"],
    ["Manage customers", "Manage customers", "Zarządzaj klientami"],
    ["New customer", "New customer", "Nowy klient"],
    ["Customer created", "Customer created", "Utworzono klienta"],
    ["Error occured while creating customer", "Error occured while creating customer", "Wystąpił błąd podczas tworzenia klienta"],
    ["Error occured while uploading logo", "Error occured while uploading logo", "Wystąpił błąd podczas wysyłania loga klienta"],
    ["Customer edited", "Customer edited", "Zakończono edycję klienta"],
    ["Error occured while editing customer", "Error occured while editing customer", "Wystąpił błąd podczas edycji klienta"],
    ["Customer deleted", "Customer deleted", "Klient usunięty"],
    ["Error occured while deleting customer", "Error occured while deleting customer", "Wystąpił błąd podczas usuwania klienta"],
    ["Do you really want to delete customer", "Do you really want to delete customer", "Czy na pewno chcesz usunąć klienta"],
    ["All projects and users related with customer will be lost", "All workspaces and users related with customer will be lost.", "Wszystkie projekty i użytkownicy związani z klientem zostaną usunięci."],
    ["License", "License", "Licencja"],
    ["License validity", "License validity", "Ważność licencji"],
    ["Unlimited", "Unlimited", "Nielimitowana"],
    ["License expires at", "License expires at", "Licencja wygasa dnia"],
    ["License has expired at", "License has expired at", "Licencja wygasła dnia"],
    ["To prolong the license contact GISonLine", "To prolong the license, contact GISonLine.", "Aby przedłużyć licencję skontaktuj się z GISonLine."],
    ["Logo", "Logo", "Logo"],
    ["Delete logo", "Delete logo", "Usuń logo"],
    ["Do you really want to delete logo", "Do you really want to delete logo", "Czy na pewno chcesz usunąć logo"],
    ["Logo uploaded", "Logo uploaded", "Logo przesłane"],
    ["Error occured while deleting logo", "Error occured while deleting logo", "Wystąpł błąd podczas usuwania logo"],
    ["Logo was deleted, you will see default logo.", "Logo was deleted, you will see default logo.", "Logo zostało usunięte, wyświetlone zostanie domyślne logo."],

    //ProjectAttributesAdmin
    ["Project attributes", "Project attributes", "Atrybuty misji"],
    ["Project attributes for", "Project attributes for ", "Atrybuty misji dla "],
    ["Enabled", "Enabled", "Włącz"],
    ["Error occured while loading project attributes", "Error occured while loading project attributes", "Wystąpił błąd podczas wczytywania atrybutów misji"],
    ["Error occured while saving project attributes", "Error occured while saving project attributes", "Wystąpił błąd podczas zapisu atrybutów misji"],
    ["Do you really want to change project attributes for", "Do you really want to change project attributes for ", "Czy na pewno chcesz zmienić atrybuty misji dla "],
    ["The customer project attributes have been successfully changed", "The customer project attributes have been successfully changed", "Atrybuty misji klienta zostały pomyślnie zmienione"],

    //ProjectAdmin
    ["Create workspace", "Create workspace", "Utwórz projekt"],
    ["Delete workspace", "Delete workspace", "Usuń projekt"],
    ["Workspace created", "Workspace created", "Utworzono projekt"],
    ["Workspace count limit reached", "Workspace count limit reached. Contact with vendor to change the license type.", "Limit projektów osiągnięty. Skontaktuj się z dostawcą w celu zmiany typu licencji."],
    ["Error occured while creating workspace", "Error occured while creating workspace", "Wystąpił błąd podczas tworzenia projektu"],
    ["Workspace deleted", "Workspace deleted", "Usunięto projekt"],
    ["Error occured while deleting workspace", "Error occured while deleting workspace", "Wystąpił błąd podczas usuwania projektu"],
    ["Do you really want to delete workspace", "Do you really want to delete workspace", "Czy na pewno chcesz usunąć projekt"],
    ["All data related with workspace will be lost", "All data related with workspace will be lost.", "Wszystkie dane związane z projektem zostaną bezpowrotnie utracone."],
    ["Your current license type", "Your current license type", "Aktualnie posiadasz licencję typu"],
    ["Workspace limit for that license", "Workspace limit for that license", "Limit projektów dla tej licencji"],
    ["Your current workspace size", "Your current workspace size", "Aktualny rozmiar projektów"],

    // UserAdmin
    ["User limit for that license", "User limit for that license", "Limit użytkowników dla tej licencji"],

    //InstanceAdmin
    ["Instance", "Instance", "Instancja"],
    ["Instances", "Instances", "Instancje"],
    ["RegisterCustomerAllowed", "Customer registration allowed", "Rejestracja klientów dozwolona"],

    // UserCreator    
    ["Create new user", "Create new user", "Utwórz użytkownika"],
    ["User created", "User created", "Utworzono użytkownika"],
    ["Error occured while creating user", "Error occured while creating user", "Wystąpił błąd podczas tworzenia użytkownika"],

    // UserList
    ["Manage users in workspaces", "Manage users in workspaces", "Zarządzaj użytkownikami w projektach"],
    ["User deleted", "User deleted", "Usunięto użytkownika"],
    ["Error occured while deleting user", "Error occured while deleting user", "Wystąpił błąd podczas usuwania użytkownika"],
    ["Do you really want to delete user", "Do you really want to delete user", "Czy na pewno chcesz usunąć użytkownika"],

    // ProjectManager
    ["Grant or revoke access", "Grant or revoke access", "Przypisz lub odbierz dostęp"],
    ["Grant", "Grant", "Przypisz"],
    ["Grant workspace", "Grant workspace", "Przypisz project"],
    ["Revoke", "Revoke", "Odbierz"],
    ["Revoke workspace", "Revoke workspace", "Odbierz project"],
    ["Workspace access granted", "Workspace access granted", "Przypisano dostęp do projektu"],
    ["Error occured while granting workspace", "Error occured while deleting workspace", "Wystąpił błąd podczas przypisywania dostępu do projektu"],
    ["Workspace access revoked", "Workspace access revoked", "Odebrano dostęp do projektu"],
    ["Error occured while revoking workspace", "Error occured while revoking workspace", "Wystąpił błąd podczas odbierania dostępu do projektu"],

    // RoleManager
    ["User role changed", "User role changed", "Zmieno rolę użytkownika"],
    ["Error occured while changing user role", "Error occured while changing user role", "Wystąpił błąd podczas zmiany roli użytkownika"],
    ["Super Admin", "Super Admin", "Super Administrator"],
    ["Admin", "Admin", "Administrator"],
    ["Expert", "Expert", "Ekspert"],
    ["Regular", "Regular", "Normalny"],
];
const enTranslations = {};
translations.forEach(value => enTranslations[value[0]] = value[1]);
const plTranslations = {};
translations.forEach(value => plTranslations[value[0]] = value[2]);

i18n.init({
    resources: {
        en: {
            translations: enTranslations
        },
        pl: {
            translations: plTranslations
        },
        fallbackLng: 'pl',
        debug: true,
        ns: ['translations'],
        defaultNS: 'translations',
        keySeparator: false,
        interpolation: {
            escapeValue: false,
            formatSeparator: ','
        },
        react: {
            wait: true
        }
    }
});

export const setLanguage = (language) => {
    if (!language) {
        language = localStorage.getItem('language');
        if (!language) {
            language = navigator.language === "pl-PL" ? 'pl' : 'en';
        }
    }
    localStorage.setItem('language', language);
    i18n.changeLanguage(language);
}
setLanguage()

export default i18n;


// WEBPACK FOOTER //
// ./src/i18n.js